module.exports = __webpack_public_path__ + "media/03.fad9c1d7.wav";